import { Form, Grid, message } from 'antd';
import { Modal } from 'components';
import { Dayjs } from 'dayjs';
import { ReportApiService } from 'features/reports/api/reports-api.service';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { UserFormValues } from 'features/users/components/users-filter-form';
import { useState } from 'react';

import { ClosingReportInfoFormItems } from './closing';

const { useBreakpoint } = Grid;

export const ClosingReportViewModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const formName = 'add-user-form';
  const screens = useBreakpoint();
  const [form] = Form.useForm<UserFormValues>();
  const [isUpdating, setIsUpdating] = useState(false);
  const [queryFilters, setQueryFilters] = useState<
    [Dayjs | null, Dayjs | null] | null
  >(null);

  const handleDate = (date: [Dayjs | null, Dayjs | null] | null) => {
    if (date && date[0] && date[1]) {
      setQueryFilters(date);
    } else {
      setQueryFilters(null);
    }
  };

  const handleUpdate = async (formData: any) => {
    setIsUpdating(true);

    const dateFrom = queryFilters?.[0]?.isValid?.()
      ? queryFilters[0].format('YYYY-MM-DD')
      : undefined;
    const dateTo = queryFilters?.[1]?.isValid?.()
      ? queryFilters[1].format('YYYY-MM-DD')
      : undefined;

    const payload: any = {
      params: {
        modelType: formData?.modelType,
        company_id: formData?.company_ids,
        facility_id: formData?.facility_ids,
        field_id: formData?.field_id,
        sports_id: formData?.sports_id,
      },
    };

    if (dateFrom && dateTo) {
      payload.params.date_from = dateFrom;
      payload.params.date_to = dateTo;
    }

    try {
      const response: any = await ReportApiService().getClosingReport(payload);

      const blob = new Blob([response.data], {
        type: 'application/octet-stream',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'closing-report.xlsx');
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      message.error('Failed to generate or download report.');
    }

    setIsUpdating(false);
  };

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        className='right-modal'
        title={'Closing Report'}
        onCancel={onClose}
        onOk={form.submit}
        okText={'Generate'}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
          loading: isUpdating, // Disable button when updating
        }}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinish={handleUpdate}
        >
          <ClosingReportInfoFormItems handleDate={handleDate} form={form} />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
